;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('ValidateErrorController', ValidateErrorController)

  ValidateErrorController.$inject = ['$uibModalInstance', 'invalidType']

  function ValidateErrorController ($uibModalInstance, invalidType) {
    const self = this
    self.invalidType = invalidType

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
